
export const KEYCODE_BACKSPACE     = 8;
export const KEYCODE_TAB           = 9;
export const KEYCODE_ENTER         = 13;
export const KEYCODE_ESCAPE        = 27;

export const KEYCODE_LEFT          = 37;
export const KEYCODE_UP            = 38;
export const KEYCODE_RIGHT         = 39;
export const KEYCODE_DOWN          = 40;

export const KEYCODE_COMMA         = 188;
export const KEYCODE_FORWARD_SLASH = 191;



// WEBPACK FOOTER //
// ./lib/keyboard.js